import React from 'react';
import * as LucideIcons from 'lucide-react';

// Helper function to get icon component by name
export const getIconByName = (iconName?: string): React.ComponentType<any> => {
  if (!iconName) return LucideIcons.Tag;
  const IconComponent = (LucideIcons as any)[iconName];
  return IconComponent || LucideIcons.Tag;
};

